var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChartPieSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M461.219 288.01H223.99V50.781C223.99 41.157 215.616 33.407 206.117 34.657C87.127 51.531 -3.99 155.397 0.135 280.136C4.259 404.125 107.875 507.741 231.864 511.865C356.603 515.99 460.469 424.873 477.343 305.883C478.593 296.384 470.843 288.01 461.219 288.01ZM288.734 0.035C279.61 -0.59 271.986 7.16 271.986 16.284V240.014H495.716C504.84 240.014 512.59 232.265 511.965 223.266C503.715 103.776 408.224 8.285 288.734 0.035Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPieSimple);
export default __webpack_public_path__ + "static/media/chart-pie-simple.64014d33419c117862d31865e99b3b7a.svg";
export { ForwardRef as ReactComponent };